import { FC } from 'react';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import styles from './login-disclaimer.module.scss';
import cx from 'classnames';

interface LoginDisclaimerProps {
  text: string;
  className?: string;
}

export const LoginDisclaimer: FC<LoginDisclaimerProps> = ({
  text,
  className
}) => {
  return (
    <div className={cx('d-flex align-items-center my-3', className)}>
      <CatIconWarningCircle className="me-2" />
      <p
        className={cx(
          styles['login-disclaimer-text'],
          'cat-u-theme-typography-body-sm mb-0'
        )}
      >
        {text}
      </p>
    </div>
  );
};
